import { BENEFITS as BENEFITS_FALLBACK } from "@/data";
import { Reveal, Overline } from "@/components/Reveal";
import { useCollection } from "@/hooks/useCollection";
import { ShieldCheck, Zap, Leaf, Droplets, Heart, Sun, Sparkles, Flower2 } from "lucide-react";

const ICONS = { ShieldCheck, Zap, Leaf, Droplets, Heart, Sun, Sparkles, Flower2 };

export const Benefits = () => {
  const { data: BENEFITS } = useCollection("benefits", "/benefits", BENEFITS_FALLBACK);
  return (
    <section id="manfaat" className="bg-cream-200 py-24 md:py-36 px-6 md:px-10">
      <div className="mx-auto max-w-7xl">
        <div className="max-w-2xl mb-16">
          <Reveal>
            <Overline>Kenapa Madu Murni</Overline>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-ink">
              Manfaat nyata untuk keseharian Anda.
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {BENEFITS.map((b, i) => {
            const Icon = ICONS[b.icon];
            return (
              <Reveal key={b.id || b.title} delay={i * 0.08}>
                <div
                  data-testid={`benefit-${i}`}
                  className="group h-full rounded-3xl bg-cream border border-border/50 p-8 hover:border-honey transition-colors duration-400 hover:shadow-[0_12px_40px_rgba(217,119,6,0.10)]"
                >
                  <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-honey-light text-brandRed group-hover:bg-honey group-hover:text-ink transition-colors duration-400">
                    <Icon size={26} strokeWidth={1.75} />
                  </div>
                  <h3 className="font-display text-2xl tracking-tight text-ink mb-3">
                    {b.title}
                  </h3>
                  <p className="text-stone2 leading-relaxed text-[15px]">{b.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
